@if (isV2) {
  <div
    class="v2-controls"
    [class.brand-disabled]="isBrandSettingsValueApplied"
    [matTooltip]="isBrandSettingsValueApplied ? ('settings.customization.brand-settings.picker-tooltip' | translate) : ''"
    matTooltipShowDelay="300">
    @if (component?.type === WidgetComponentType.Image) {
      <button type="button" class="v2-link-toggle" [class.linked]="isSet" [disabled]="checkboxDisabled" (click)="isSet = !isSet; toggleCheckbox()">
        <mat-icon>{{ isSet ? "link" : "link_off" }}</mat-icon>
      </button>
    }
    @if (component?.type !== WidgetComponentType.Image || isSet) {
      <mat-slider class="v2-slider" [min]="minValue" [max]="v2SliderMax" [disabled]="disabled" #ngSlider>
        <input matSliderThumb [value]="currentValue || 0" (input)="v2SliderInput(ngSliderThumb.value)" #ngSliderThumb="matSliderThumb" />
      </mat-slider>
      <div class="v2-input-group">
        <input
          type="number"
          [min]="minValue"
          [max]="currentUnit === '%' ? 100 : v2Max || null"
          [value]="currentValue"
          (input)="v2InputChange($event)"
          [disabled]="disabled" />
        @if (pixelAllowed && percentAllowed) {
          <mat-form-field class="v2-unit-select-field">
            <mat-select [value]="currentUnit" (selectionChange)="v2UnitChange($event.value)" panelClass="v2-unit-select-panel">
              <mat-option value="px">px</mat-option>
              <mat-option value="%">%</mat-option>
            </mat-select>
          </mat-form-field>
        } @else {
          <span class="v2-unit-label">{{ pixelAllowed ? "px" : "%" }}</span>
        }
      </div>
    }
  </div>
} @else {
  <div class="dimension-picker">
    @if (typeControl !== "radio") {
      @if (!isOnlySlider && !isEmbeddedComp) {
        <mat-checkbox class="sidebar-edit-checkbox" [(ngModel)]="isSet" [disabled]="checkboxDisabled" (change)="toggleCheckbox()">
          <div class="sidebar-edit-item-text">{{ label }}</div>
        </mat-checkbox>
      }
    }
    @if (!isOnlySlider && isEmbeddedComp) {
      <div class="sidebar-edit-item-text">{{ label }}</div>
    }

    @if (showEditingDevice && isSet && !isOnlySlider) {
      <mat-button-toggle-group
        [(ngModel)]="currentEditingDevice"
        (change)="updateEditingDevice()"
        class="device-toggle-buttons"
        hideSingleSelectionIndicator="true">
        <mat-button-toggle value="{{ EditingDevices.Any }}" matTooltip="{{ 'campaign.widget.device-setting-any' | translate }}">
          <mat-icon>devices</mat-icon>
        </mat-button-toggle>
        <mat-button-toggle
          value="{{ EditingDevices.Mobile }}"
          [disabled]="disableMobileEditingDevice"
          matTooltip="{{
            (disableMobileEditingDevice ? 'campaign.widget.device-setting-mobile-disabled-full-width' : 'campaign.widget.device-setting-mobile') | translate
          }}">
          <mat-icon>phone_iphone</mat-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>
    }
    @if ((isSet && !isOnlySlider) || isEmbeddedComp) {
      <mat-form-field class="small-input-field">
        <input
          matInput
          [required]="isEmbeddedComp && dimensionType === DimensionType.MinWidth ? false : true"
          type="number"
          [min]="minValue"
          [max]="currentUnit === '%' ? 100 : null"
          [(ngModel)]="currentValue"
          (input)="inputData($event)"
          (change)="onChange()"
          [disabled]="disabled" />
        @if (isInvalid && currentValue < minValue) {
          <mat-hint class="invalid-hint">{{ "generic.required" | translate }}</mat-hint>
        }
      </mat-form-field>
    }
    @if (
      (!isOnlySlider && isSet && pixelAllowed && !percentAllowed) ||
      (!pixelAllowed && percentAllowed) ||
      (pixelAllowed && !percentAllowed && !isSet && isEmbeddedComp)
    ) {
      <span class="px-or-percent-dropdown px-label-unit">
        {{ pixelAllowed ? "px" : "%" }}
      </span>
    }
    @if (!isOnlySlider && isSet && pixelAllowed && percentAllowed) {
      <mat-form-field class="px-or-percent-dropdown">
        <mat-select [(value)]="currentUnit" (selectionChange)="onChange()">
          @if (pixelAllowed) {
            <mat-option value="px">px</mat-option>
          }
          @if (percentAllowed) {
            <mat-option value="%">%</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (
      (((pixelAllowed && currentUnit === "px") || isPercentSlider) && isSet && !sliderDisabled && !isEmbeddedComp) ||
      isOnlySlider
    ) {
      <mat-slider
        [class]="showEditingDevice ? 'mobile-view' : ''"
        [disabled]="disabled"
        #slider
        [min]="sliderMin"
        [max]="sliderMax"
        (window:mouseup)="resetSlider()"
        #ngSlider>
        <input
          matSliderThumb
          [value]="sliderVal"
          (input)="updateSlider({ source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value })"
          #ngSliderThumb="matSliderThumb" />
      </mat-slider>
    }
  </div>

  @if (isSet) {
    <app-link-to-brand-variables
      [isDefaultValue]="true"
      [isBrandSettingsValueApplied]="isBrandSettingsValueApplied"
      [brandSettingsValue]="brandSettingsValue"
      (apply)="applyBrandSettings()"></app-link-to-brand-variables>
  }
}
